export default __webpack_public_path__ + "static/media/green.8ca33e3f.svg";